import React, { useState, useCallback, useEffect } from "react";
import MainContainer from "../../container/MainContainer";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { useHistory } from "react-router";
import ScheduleTime from "../Posts/ScheduleTime";
import Arrow from "../../images/Arrow-Right.svg";
import { Link } from "react-router-dom";
import timer from "../../images/time.svg";
import PostSchedule from "../Popup/PostSchedule";
import PublishedPost from "../Popup/PublishedPost";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { GET_POST_BY_ID } from "../../query/GetPostById";
import { EDIT_POST } from "../../mutation/EditPost";
import moment from "moment";
import UploadImage from "../Common/upload-image/UploadImage";
import ImageKit from "imagekit-javascript";

const EditPostLayout = (props) => {
  const { id } = props.match.params;

  const [editorState, setEditorState] = useState("");
  const { data, refetch } = useQuery(GET_POST_BY_ID, {
    client: hasuraClient,
    variables: {
      id: id,
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  React.useEffect(() => {
    if (data) {
      const content2 = data?.posts_by_pk?.content;
      setTextContent(content2);
      const editorState2 = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(data?.posts_by_pk?.parse_body)
        )
      );
      setEditorState(editorState2);
      setParseContent(data?.posts_by_pk?.parse_body);
      if (data?.posts_by_pk?.image_url) {
        setUploadedImg(data?.posts_by_pk?.image_url);
      }
    }
  }, [data]);

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);

  const [openTimeComponent, setopenTimeComponent] = useState(false);

  const history = useHistory();

  const [textContent, setTextContent] = useState("");
  const [parseContent, setParseContent] = useState("<div></div>");

  const [imageLoading, setImageLoading] = useState(false);
  const [uploadedImg, setUploadedImg] = useState("");
  const [imageName, setImageName] = useState("");
  const [startFutureError, setStartFutureError] = useState(false);
  const profileId = localStorage.getItem("profile_id");
  const [uploadedImgError, setUploadedImgError] = useState("");
  const [textError, setTextError] = useState("");

  const [startDate, setStartDate] = useState(new Date());
  const [time, setTime] = useState();
  const [time2, setTime2] = useState();
  const [date2, setDate2] = useState();
  const timeshow = time || new Date();
  var timeAndDate = moment(date2 + " " + time2);

  const [EditPostMutation] = useMutation(EDIT_POST, {
    client: hasuraClient,
  });
  const updateClickHandler = () => {
    if (textContent != "" && uploadedImg !== "") {
      let string1 = `<!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          
        </head>
      <body>

      ${parseContent}
      `;

      let string2 = `</body> </html>`;
      EditPostMutation({
        variables: {
          content: textContent,
          publish_time: data?.posts_by_pk?.publish_time,
          status: data?.posts_by_pk?.status,
          id: id,
          parse_body: parseContent,
          image_path: `/dev/business_profile/${profileId}/${imageName}`,
          image_url: uploadedImg,
          mobile_body: string1.concat(string2).replace(/\n/g, ""),
        },
      })
        .then(() => {
          history.push("/posts");
        })
        .catch(() => {});
    } else {
      if (uploadedImg === "") {
        setUploadedImgError(true);
      } else {
        setUploadedImgError(false);
      }

      if (textContent === "") {
        setTextError(true);
      } else {
        setTextError(false);
      }
    }
  };

  const publishClickHandler = () => {
    if (textContent != "" && uploadedImg !== "") {
      let string1 = `<!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          
        </head>
      <body>

      ${parseContent}
      `;

      let string2 = `</body> </html>`;
      EditPostMutation({
        variables: {
          content: textContent,
          id: id,
          publish_time: new Date().toISOString(),
          status: "published",
          parse_body: parseContent,
          image_path: `/dev/business_profile/${profileId}/${imageName}`,
          image_url: uploadedImg,
          mobile_body: string1.concat(string2).replace(/\n/g, ""),
        },
      })
        .then(() => {
          setModalShow(true);
        })
        .catch(() => {});
    } else {
      if (uploadedImg === "") {
        setUploadedImgError(true);
      } else {
        setUploadedImgError(false);
      }

      if (textContent === "") {
        setTextError(true);
      } else {
        setTextError(false);
      }
    }
  };

  const publishLaterClickHandler = () => {
    let startFutureErrorVal = false;
    if (moment(startDate).unix() <= moment().unix()) {
      if (moment(time).unix() <= moment().unix()) {
        startFutureErrorVal = true;
        setStartFutureError(true);
      } else {
        setStartFutureError(false);
        startFutureErrorVal = false;
      }
    }

    if (
      textContent != "" &&
      uploadedImg !== "" &&
      startFutureErrorVal === false &&
      moment(timeAndDate).toISOString() != null
    ) {
      let string1 = `<!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          
        </head>
      <body>

      ${parseContent}
      `;

      let string2 = `</body> </html>`;
      EditPostMutation({
        variables: {
          content: textContent,
          publish_time: moment(timeAndDate).toISOString(),
          status: "scheduled",
          id: id,
          parse_body: parseContent,
          image_path: `/dev/business_profile/${profileId}/${imageName}`,
          image_url: uploadedImg,
          mobile_body: string1.concat(string2).replace(/\n/g, ""),
        },
      })
        .then(() => {
          setopenTimeComponent(false);
          setModalShow2(true);
        })
        .catch((e) => {
          setopenTimeComponent(false);
        });
    } else {
      if (uploadedImg === "") {
        setUploadedImgError(true);
      } else {
        setUploadedImgError(false);
      }

      if (textContent === "") {
        setTextError(true);
      } else {
        setTextError(false);
      }
    }
  };
  const draftClickHandler = () => {
    if (textContent != "" && uploadedImg !== "") {
      let string1 = `<!DOCTYPE html>
      <html lang="en">
        <head> <meta charset="utf-8" /> <meta http-equiv="X-UA-Compatible" content="IE=edge" /> <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" /> 
        </head>
      <body>
      ${parseContent}
      `;

      let string2 = `</body> 
                    </html>`;
      EditPostMutation({
        variables: {
          parse_body: parseContent,
          image_path: `/dev/business_profile/${profileId}/${imageName}`,
          image_url: uploadedImg,
          content: textContent,
          status: "draft",
          id: id,
          mobile_body: string1.concat(string2).replace(/\n/g, ""),
        },
      })
        .then(() => {
          history.push("/posts");
        })
        .catch(() => {});
    } else {
      if (uploadedImg === "") {
        setUploadedImgError(true);
      } else {
        setUploadedImgError(false);
      }

      if (textContent === "") {
        setTextError(true);
      } else {
        setTextError(false);
      }
    }
  };

  const imageKit = new ImageKit({
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });

  const handleImageUpload = async (imgObj) => {
    setImageLoading(true);

    await imageKit.upload(
      {
        file: imgObj,
        fileName: imgObj.name,
        tags: ["tag1"],
        folder: "/dev/business",
      },
      (err, result) => {
        if (result) {
          setUploadedImg(
            imageKit.url({
              src: result.url,
            })
          );

          setImageName(imgObj.name);
          setUploadedImgError(false);

          setImageLoading(false);
        }
      }
    );
  };

  const onImageDrop = useCallback((acceptedFiles) => {
    handleImageUpload(acceptedFiles[0]);
  }, []);

  return (
    <MainContainer>
      <section className="post-block">
        <div className="main-title">
          <div className="back-button">
            <Link
              to="#"
              onClick={() => {
                history.goBack();
              }}
            >
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h1>Edit Post</h1>
          </div>
        </div>
        <div className="create-post-cover">
          <div className="col-post-left">
            <div className="editor-box-cover">
              <div className="editor-box">
                <Editor
                  editorState={editorState}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={(editorStateVal) => {
                    setEditorState(editorStateVal);

                    let editorSourceHTML = draftToHtml(
                      convertToRaw(editorStateVal.getCurrentContent())
                    );

                    setParseContent(editorSourceHTML);
                    const raw = convertToRaw(
                      editorStateVal.getCurrentContent()
                    );

                    let text = "";

                    for (let i = 0; i < raw.blocks.length; i++) {
                      if (raw.blocks[i].type !== "atomic") {
                        text += raw.blocks[i].text;
                      }
                    }
                    setTextContent(text);
                  }}
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "fontFamily",
                      "list",
                      "textAlign",
                      "link",
                      "emoji",
                    ],
                    inline: {
                      options: ["bold", "italic", "underline"],
                    },
                  }}
                />
                {/* <input type="text" onChange={(e)=>setTextContent(e.target.value)}/> */}
              </div>
              <p hidden={!textError} className="error-message">
                Post Title required
              </p>

              <div className="button-row">
                {data?.posts_by_pk?.status != "draft" ? (
                  <button
                    className="update-post"
                    onClick={() => updateClickHandler()}
                  >
                    Update Post
                  </button>
                ) : (
                  <div className="publish-btn">
                    <button
                      className="publish-post"
                      onClick={() => publishClickHandler()}
                    >
                      publish post
                    </button>
                    <PublishedPost
                      show={modalShow}
                      onHide={() => {
                        history.push("/posts");
                        setModalShow(false);
                      }}
                    />
                    <PostSchedule
                      show={modalShow2}
                      publisedTime={moment(timeAndDate).toISOString()}
                      onHide={() => {
                        history.push("/posts");
                        setModalShow2(false);
                      }}
                    />

                    {openTimeComponent ? (
                      <div className="timer-box">
                        <ScheduleTime
                          setTime={setTime}
                          setTime2={setTime2}
                          setDate2={setDate2}
                          setStartDate={setStartDate}
                          timeshow={timeshow}
                          publishLaterClickHandler={publishLaterClickHandler}
                          setopenTimeComponent={setopenTimeComponent}
                          startFutureError={startFutureError}
                        />
                      </div>
                    ) : null}
                    <button
                      className="timer-btn"
                      onClick={() => setopenTimeComponent(!openTimeComponent)}
                    >
                      <img src={timer} alt="timer" />
                    </button>
                  </div>
                )}
                <button
                  className="save-drafts-btn"
                  onClick={() => draftClickHandler()}
                >
                  Save as draft
                </button>
              </div>
            </div>
          </div>

          <div>
            <UploadImage
              onImageDrop={onImageDrop}
              disabled={!!uploadedImg}
              uploadedImg={uploadedImg}
              setUploadedImg={setUploadedImg}
              loading={imageLoading}
            />
            <p hidden={!uploadedImgError} className="error-message">
              Image required
            </p>
          </div>
        </div>

        <div></div>
      </section>
    </MainContainer>
  );
};

export default EditPostLayout;
